import { hatchBurnedRgba } from "../shared/burned-hatch";

/** Fetch the EFFIS GetMap and return a darker hatched data URL. Falls back to the raw URL. */
export async function styleBurnedOverlay(url: string): Promise<string> {
  try {
    const img = await loadCrossOrigin(url);
    const canvas = document.createElement("canvas");
    canvas.width = img.width;
    canvas.height = img.height;
    const ctx = canvas.getContext("2d");
    if (!ctx) return url;
    ctx.drawImage(img, 0, 0);
    const data = ctx.getImageData(0, 0, canvas.width, canvas.height);
    hatchBurnedRgba(data.data, canvas.width, canvas.height);
    ctx.putImageData(data, 0, 0);
    return canvas.toDataURL("image/png");
  } catch {
    return url;
  }
}

function loadCrossOrigin(url: string): Promise<HTMLImageElement> {
  return new Promise((resolve, reject) => {
    const img = new Image();
    img.crossOrigin = "anonymous";
    img.onload = () => resolve(img);
    img.onerror = () => reject(new Error("burned overlay fetch"));
    img.src = url;
  });
}
